var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, Fragment, useContext } from 'react';
import { Pressable, View } from 'react-native';
import { BLACK_600, BLACK_700 } from '../../constants/colors';
import { RightChevronIcon } from '../../icons';
import { StateConfigContext } from '../../providers';
import { checkIsPlatform, getTestId, isLastItem } from '../../utils';
import { Typography } from '../typography';
import { getBreadcrumbProps, getBreadcrumbStyles } from './BreadcrumbStyles';
export var Breadcrumb = forwardRef((props, ref) => {
  var stateContext = useContext(StateConfigContext);
  var breadcrumbProps = getBreadcrumbProps(props, stateContext);
  var breadcrumbStyles = getBreadcrumbStyles();
  var data = props.data,
    onClickHandler = props.onClickHandler,
    maxDisplayedItems = props.maxDisplayedItems,
    overflowIndex = props.overflowIndex,
    style = props.style,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'Breadcrumb' : _props$testID,
    restProps = __rest(props, ["data", "onClickHandler", "maxDisplayedItems", "overflowIndex", "style", "testID"]);
  var defaultDatalength = maxDisplayedItems || 4;
  var lastIndex = (data === null || data === void 0 ? void 0 : data.length) - 1;
  var itemBeforeEllipsis = data.slice(0, overflowIndex);
  var itemsAfterEllipsis = maxDisplayedItems < data.length && data.slice(overflowIndex).slice(-maxDisplayedItems + overflowIndex);
  var breadcrumbData = (() => {
    if (maxDisplayedItems <= overflowIndex) return data.slice(0, maxDisplayedItems);else if (data.length > defaultDatalength && maxDisplayedItems < data.length) return itemBeforeEllipsis.concat(itemsAfterEllipsis);else return data;
  })();
  var showEllipsis = index => {
    return data.length > defaultDatalength && maxDisplayedItems > overflowIndex && index === overflowIndex - 1;
  };
  var getSeperator = (index, data) => {
    var _a, _b, _c;
    var lastIndex = data.length - 1;
    var isActive = index === lastIndex ? true : false;
    var currentBreadcrumb = (data === null || data === void 0 ? void 0 : data[index]) || {};
    var isdisabled = currentBreadcrumb === null || currentBreadcrumb === void 0 ? void 0 : currentBreadcrumb.disabled;
    var color = isActive ? (_a = breadcrumbProps === null || breadcrumbProps === void 0 ? void 0 : breadcrumbProps.config) === null || _a === void 0 ? void 0 : _a.activeColor : (_b = breadcrumbProps === null || breadcrumbProps === void 0 ? void 0 : breadcrumbProps.config) === null || _b === void 0 ? void 0 : _b.inactiveColor;
    var typographyColor = isdisabled ? (_c = breadcrumbProps === null || breadcrumbProps === void 0 ? void 0 : breadcrumbProps.config) === null || _c === void 0 ? void 0 : _c.disabledColor : color;
    return _jsxs(View, Object.assign({
      style: [breadcrumbStyles === null || breadcrumbStyles === void 0 ? void 0 : breadcrumbStyles.rowContainer, style]
    }, restProps, {
      children: [_jsx(Typography, Object.assign({
        color: typographyColor,
        type: "body-single-line-xs"
      }, currentBreadcrumb, getTestId(testID, 'currentBreadcrumb'))), lastIndex !== index && _jsx(RightChevronIcon, Object.assign({
        style: breadcrumbStyles.icon,
        color: BLACK_600,
        fontSize: 15
      }, getTestId(testID, 'rightChevronIcon')))]
    }));
  };
  var onBreadcrumbHandler = (event, index, item) => {
    if (lastIndex === index) return;
    onClickHandler(event, {
      index,
      item
    });
  };
  return _jsx(View, Object.assign({
    ref: ref,
    style: breadcrumbStyles === null || breadcrumbStyles === void 0 ? void 0 : breadcrumbStyles.rowContainer
  }, getTestId(testID), {
    children: maxDisplayedItems !== 0 && (breadcrumbData === null || breadcrumbData === void 0 ? void 0 : breadcrumbData.map((item, index) => {
      var _a;
      var isDisabled = (item === null || item === void 0 ? void 0 : item.disabled) || isLastItem(breadcrumbData, index);
      return _jsxs(Fragment, {
        children: [_jsx(Pressable, Object.assign({
          onPress: event => {
            if (!isDisabled) onBreadcrumbHandler(event, index, item);
          }
        }, (isDisabled || (item === null || item === void 0 ? void 0 : item.isHyperLink)) && checkIsPlatform('web') && {
          tabIndex: null
        }, {
          children: getSeperator(index, breadcrumbData)
        }), "breadcrumb_" + item.text + "_" + index), showEllipsis(index) && _jsxs(View, Object.assign({
          style: breadcrumbStyles === null || breadcrumbStyles === void 0 ? void 0 : breadcrumbStyles.rowContainer
        }, {
          children: [_jsx(Typography, Object.assign({
            color: BLACK_700,
            text: '...',
            type: "body-single-line-xs"
          }, checkIsPlatform('web') && {
            'aria-hidden': true
          })), index !== lastIndex && _jsx(RightChevronIcon, Object.assign({
            color: (_a = breadcrumbProps === null || breadcrumbProps === void 0 ? void 0 : breadcrumbProps.config) === null || _a === void 0 ? void 0 : _a.iconColor,
            fontSize: 16,
            style: breadcrumbStyles.icon
          }, getTestId(testID, 'rightChevronIcon')))]
        }))]
      }, "breadcrumb_" + item.text + "_" + index);
    }))
  }));
});